import { Component, Input, OnInit } from '@angular/core';

import { StateService } from '@uirouter/angular';
import { AdminService } from '../../../services/core.admin.service';

import * as _ from 'lodash-es';
import { FilterService } from '../../../services/core.filter.service';
import { ProjectService } from '../../../services/project.service';
import { UiService } from '../../../services/core.ui.service';
import { GfTranslateService } from '../../../services/core.translate.service';
import { OrgHelper } from '../services/admin.org-helper.service';
import { GfTitleService } from '../../../services/core.title.service';
import { SiteConfigService } from '../../../services/core.site-config.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { AdminDeleteProjectComponent } from './project-delete-modal/admin.project-delete.component';
import { AdminEditProjectComponent } from './project-edit-modal/admin.project-edit.component';
import { getParamsFromAllowedKeys } from '../../../config/core.httpclient-utils';

@Component({
    selector: 'adminProjectsView',
    template: require('./admin.projects.component.html')
})
export class AdminProjectsViewComponent implements OnInit {
    adminOpen = false;

    siteConfig: any = null;

    projects: any = null;
    project = false;
    YesNo = {
        'Yes': '1',
        'No': '0'
    };
    configLoaded = false;

    sortFields: any;
    sort: any;
    paging: any;
    projectStatus;
    baseFilters: any;
    filters: any;
    deleteProject: any = false;
    template: any;

    constructor(
        
        private stateService: StateService, 
        private $window: Window,
        private adminService: AdminService,
        protected orgHelper: OrgHelper,
        private filterService: FilterService,
        private gfTranslateService: GfTranslateService,
        private projectService: ProjectService,
        private uiService: UiService,
        private siteConfigService: SiteConfigService,
        private modalService: NgbModal,
        private titleService: GfTitleService,
    ) { }
    
    ngOnInit() {
        this.siteConfig = this.siteConfigService.getSiteConfig();
        this.titleService.setTitle('Site Admin', this.gfTranslateService.translate('Projects'));

        this.sortFields = { id: 'id', unixName: this.gfTranslateService.translate('Unix Name') };
        this.sort = this.filterService.getSortValues();
        this.paging = this.filterService.getPagingValues();

        this.baseFilters = this.getFilters();

        this.filters = {
            main_fields: this.filterService.setFilterValues(_.cloneDeep(this.baseFilters), {})
        };

        this.getConfigSettings();

        this.fetchData();
    };

    onApplyFilters() {
        this.paging.page_num = 1;
        this.applyFilters();
    };

    onResetFilters() {
        this.paging.page_num = 1;
        this.filters = {
            main_fields: _.cloneDeep(this.baseFilters)
        };
        this.applyFilters();
    };

    onSort(params) {
        this.sort = {
            sort_field: _.get(params, 'key', 'id'),
            sort_dir: _.get(params, 'sortDir', 'asc')
        };
        this.applyFilters();
    };

    onPaging(params) {
        _.assignIn(this.paging, params);
        this.applyFilters();
    };

    exportQuery(format: string) {
        //ToDo: change this to use angular's route object when
        //the router is migrated to angular from angularjs
        // Build the params the same way fetchData() does (via getFetchArgs),
        // NOT from raw stateService.params: getFetchArgs() strips
        // undefined/null/'' so "Any"/unset filters never serialize as
        // status=undefined/status=any, which the backend would treat as real
        // filters and return an empty file.
        const params: any = this.filterService.getFetchArgs({});

        params['page_size'] = 0;
        params['format'] = format;
        params['download'] = true;

        // Only include API-relevant params using whitelist
        const allowedKeys = ['name', 'text', 'status', 'isPublic', 'inOrg', 'projectAdmin', 'createDate', 'noActivity', 'orphaned', 'isTemplate', 'page_num', 'page_size', 'sort_field', 'sort_dir', 'format', 'download'];
        const queryString = getParamsFromAllowedKeys(params, allowedKeys).toString();

        window.open('/api/project?' + queryString, '_blank'); // Open in a new tab
    };

    updateFilters(changes) {
        this.applyFilters(changes);
    };

    setTemplateProject(item) {
        this.adminService.postConfig({section: 'config', refId: 0, settingName: 'system.next-template-project', settingValue: _.get(item, 'id', 0)});
    };

    setRequireCaptcha(newValue) {
        if (newValue == undefined || this.siteConfig.requireProjectCaptcha == newValue) return false;
        this.siteConfig.requireProjectCaptcha = newValue;
        this.adminService.postConfig({section: 'config', refId: 0, settingName: 'system.requireProjectCaptcha', settingValue: newValue});
    };

    setAutoApprove(newValue) {
        if (newValue == undefined || this.siteConfig.autoApproveProjects == newValue) return false;
        this.siteConfig.autoApproveProjects = newValue;
        this.adminService.postConfig({section: 'config', refId: 0, settingName: 'system.autoApproveProjects', settingValue: newValue});
    };

    setAllowTemplate(newValue) {
        if (newValue == undefined || this.siteConfig.allowTemplateSelect == newValue) return false;
        this.siteConfig.allowTemplateSelect = newValue;
        this.adminService.postConfig({section: 'config', refId: 0, settingName: 'system.allowTemplateSelect', settingValue: newValue});
    };

    editProject($event, project) {
        $event && 
            $event.stopPropagation() &&
            $event.preventDefault();
                    
        this.projectService.details(project.unixName, { rel: 'admins' })
        .then((p: any) => {
            const modalRef = this.modalService.open(AdminEditProjectComponent);
            modalRef.componentInstance.project = p;
            modalRef.componentInstance.close.subscribe((success) => {
                modalRef.close();
                if (success) this.fetchData();
            });
        }, (response) => {
            console.log(response);
        });
    };

    setVisibility = ($event, item) => {
        $event && 
            $event.stopPropagation() &&
            $event.preventDefault();

        var project = {
            isPublic: item.isPublic === 'Y' ? 'N' : 'Y'
        };

        var newVisibility = project.isPublic === 'Y' ? 'Public' : 'Private';

        this.projectService.save(item.unixName, project)
            .then(
                () => {
                    item.isPublic = project.isPublic;
                    this.uiService.message.showSuccess(
                        this.gfTranslateService.translate('Project {{name}} is now {{visibility}}', { name: item.name, visibility: newVisibility }),
                        this.gfTranslateService.translate('Project Update')
                    );
                },
                (response) => {
                    console.log(response);
                    this.uiService.message.showError(
                        this.gfTranslateService.translate('Sorry, could not update the project visibility for {{name}}', item),
                        this.gfTranslateService.translate('Project Update')
                    );
                }
            );
    };

    changeStatus($event, item, status) {
        var project = {
            status: status
        };

        this.projectService.save(item.unixName, project)
            .then(
                () => {
                    item.status = status;
                    this.uiService.message.showSuccess(
                        this.gfTranslateService.translate('Updated project status for {{name}}', item),
                        this.gfTranslateService.translate('Update Project')
                    );
                },
                (response) => {
                    if (_.get(response, 'data.templateProjectId[0].type', false) == 'projectExists') {
                        this.uiService.message.showWarning(
                            this.gfTranslateService.translate("Sorry, cannot approve this Project.  The template project is not valid."),
                            this.gfTranslateService.translate("Approve Project")
                        );
                    } else {
                        console.log(response);
                        var defaultMsg = this.gfTranslateService.translate('Sorry, could not change the status for {{name}}', item);
                        this.uiService.message.showWarning(
                            _.get(response, 'data', defaultMsg),
                            this.gfTranslateService.translate("Update Project")
                        );
                    }
                }
            );
    };

    toggleTemplate(project) {
        var data = {
            isTemplate: (project.isTemplate == 'Y') ? 'N' : 'Y'
        };

        this.projectService.save(project.unixName, data)
            .then(
                () => {
                    project.isTemplate = data.isTemplate;
                },
                (response) => {
                    console.log(response);
                    this.uiService.message.showWarning(
                        this.gfTranslateService.translate("Sorry, could not update the Template status for {{name}}", project),
                        this.gfTranslateService.translate("Project Admin")
                    );
                }
            );
    };

    removeProject($event, p) {
        console.log('removeProject');
        $event && 
            $event.stopPropagation() &&
            $event.preventDefault();
        
        if (!p) {
            this.uiService.message.showSuccess(
                this.gfTranslateService.translate('Select a project to delete'),
                this.gfTranslateService.translate('Delete Project')
            );
            return false;
        }

        const modalRef = this.modalService.open(AdminDeleteProjectComponent);
        modalRef.componentInstance.project = p;
        modalRef.componentInstance.close.subscribe((success) => {
            modalRef.close();
            if (success) this.fetchData();
        });
    };

    getConfigSettings() {
        var promises = [
            this.adminService.getConfig('config', 0, 'system.next-template-project', 0),
            this.adminService.getConfig('config', 0, 'system.requireProjectCaptcha', 0),
            this.adminService.getConfig('config', 0, 'system.autoApproveProjects', 0)
        ];

        Promise.all(promises)
            .then((results) => {
                this.template = {
                    templateProjectId: _.get(results, '[0].settingValue', 0)
                };
                this.siteConfig.requireProjectCaptcha = _.get(results, '[1].settingValue', 0) == 1 ? 1 : 0;
                this.siteConfig.autoApproveProjects = _.get(results, '[2].settingValue', 0) == 1 ? 1 : 0;
            }).finally(() => {
                this.configLoaded = true;
            });
    }

    fetchData = () => {
        this.projects = false;

        var fetchArgs = this.filterService.getFetchArgs({ 'rel': 'disk' });

        this.adminService.projects(fetchArgs)
            .then((response) => {
                this.projects = _.map(
                    _.get(response, 'items', []),
                    this.addDiskUsageData
                );
            }, (response) => {
                console.log(response);

                var msg = this.gfTranslateService.translate('Sorry, could not get the list of projects');
                this.uiService.message.showWarning(msg, 'Data Error');

                this.projects = [];
            });
    };

    applyFilters(overrides = {}) {
        var newParams = _.pickBy(Object.assign(
            { unixName: this.stateService.params.unixName },
            this.sort,
            this.paging,
            this.filterService.getFilterValues(
                _.get(this.filters, 'main_fields', [])
            ),
            overrides
        ), (value) => {
            return (undefined != value && null != value && value != '');
        });

        this.stateService.go('.', newParams, { inherit: false }).then(this.fetchData);
    }

    addDiskUsageData(p) {
        var du = _.get(p, "rel.disk[0]['bytes']", 0);
        p.diskUsage = Math.round( (du / 1024) / 1024 );
        return p;
    }

    getFilters() {

        var any = this.filterService.getAnyFilterObj();

        return [
            { alias: "name", fieldName: "Project Name", value: "", fieldType: 4, isExtraField: false },
            { alias: "text", fieldName: "Text Search", value: "", fieldType: 4, isExtraField: false },
            {
                alias: "status",
                fieldName: this.gfTranslateService.translate("Status"),
                value: any,
                fieldType: 1,
                isExtraField: false,
                fieldElements: [any, { id: '0', label: "Pending" }, { id: '1', label: "Active" }, { id: '3', label: "Holding" }]
            },
            {
                alias: "isPublic",
                fieldName: this.gfTranslateService.translate("Visibility"),
                value: any,
                fieldType: 1,
                isExtraField: false,
                fieldElements: [any, { id: 'Y', label: "Public" }, { id: 'N', label: "Private" }]
            },
            {
                alias: "inOrg",
                fieldName: this.gfTranslateService.translate("Parent Org"),
                value: "",
                fieldType: 4,
                isExtraField: false
            },
            {
                alias: "projectAdmin",
                fieldName: this.gfTranslateService.translate("Project Admin"),
                value: "",
                fieldType: 4,
                isExtraField: false
            },
            {
                alias: "createDate",
                fieldName: this.gfTranslateService.translate("Created Since"),
                value: "",
                fieldType: 9,
                isExtraField: false
            },
            {
                alias: "noActivity",
                fieldName: this.gfTranslateService.translate("No Activity Since"),
                value: any,
                fieldType: 1,
                isExtraField: false,
                fieldElements: [
                    any,
                    { id: '-14 days', label: this.gfTranslateService.translate("2 Weeks") },
                    { id: '-30 days', label: this.gfTranslateService.translate("1 Month") },
                    { id: '-90 days', label: this.gfTranslateService.translate("3 Months") },
                    { id: '-180 days', label: this.gfTranslateService.translate("6 Months") },
                    { id: '-365 days', label: this.gfTranslateService.translate("Last Year") }
                ]
            },
            {
                alias: "orphaned",
                fieldName: this.gfTranslateService.translate("No Active Users"),
                value: any,
                fieldType: 1,
                isExtraField: false,
                fieldElements: [any, { id: 'Y', label: "Yes" }, { id: 'N', label: "No" }]
            },
            {
                alias: "isTemplate",
                fieldName: this.gfTranslateService.translate("Template"),
                value: any,
                fieldType: 1,
                isExtraField: false,
                fieldElements: [any, { id: 'Y', label: "Yes" }, { id: 'N', label: "No" }]
            },
        ];
    }
}
